import { BrowserRouter } from 'react-router-dom'

import { BandejaDeDownloads } from '@/components/ui/BandejaDeDownloads'
import { ContainerDeToasts } from '@/components/ui/Toast'
import { AppContext, FlagsmithAppProvider } from '@/contexts'
import { ContextoDeNotificacoesGlobal } from '@/contexts/contexto-notificacoes'
import { AuthProvider, useClarity } from '@/hooks'

function App(): JSX.Element {
  useClarity()

  return (
    <BrowserRouter>
      <AuthProvider>
        <FlagsmithAppProvider>
          <ContextoDeNotificacoesGlobal>
            <AppContext />
          </ContextoDeNotificacoesGlobal>

          <BandejaDeDownloads />
          <ContainerDeToasts />
        </FlagsmithAppProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
